import { Card, Row, Col, Form, Button, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateLeft, faFileExcel, faPenToSquare, faTrash, faCircleNotch, faMagnifyingGlassPlus,  faUserPlus, faPause, faSquareCheck,  faSignature, faFilePdf,  faInfoCircle, faCirclePlay, faThList, faCirclePlus  } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from 'xlsx';


import Select from 'react-select';


import Swal from "sweetalert2";


//DATEPICKER
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import "./OrdersMainTable.css"
import NewOrderModal from '../NewOrderModal/NewOrderModal';
import EditOrderModal from '../EditOrderModal/EditOrderModal';
import CloseOrderModal from '../CloseOrderModal/CloseOrderModal';
import PauseOrderModal from '../PauseOrderModal/PauseOrderModal';

import { useEffect, useState } from 'react';
import SignatureOrderModal from '../SignatureOrderModal/SignatureOrderModal';
import InfoOrderModal from '../InfoOrderModal/InfoOrderModal';
import LogOrderModal from '../LogOrderModal/LogOrderModal';

import AssignTechnicalModal from '../AssignTechnicalModal/AssignTechnicalModal';

import moment from 'moment';

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";


const OrdersMainTable = () => {
    
    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //ADD ORDER MODAL CONTROLLER
    const [showModal_AddOrder, setShowModal_AddOrder] = useState(false);   
    const requestCloseModal_AddOrder = () => { setShowModal_AddOrder(false); getOrderListingTable(); }
    const openModal_AddOrder = () => { setShowModal_AddOrder(true); }

    //EDIT ORDER MODAL CONTROLLER
    const [showModal_EditOrder, setShowModal_EditOrder] = useState(false);   
    const requestCloseModal_EditOrder = () => { setShowModal_EditOrder(false); getOrderListingTable(); }
    const openModal_EditOrder = () => { setShowModal_EditOrder(true); }

    //ASSIGN MODAL CONTROLLER
    const [showModal_AssignOrder, setShowModal_AssignOrder] = useState(false);   
    const requestCloseModal_AssignOrder = () => { setShowModal_AssignOrder(false); getOrderListingTable(); }
    const openModal_AssignOrder = () => { setShowModal_AssignOrder(true); }

    //CLOSE ORDER MODAL CONTROLLER
    const [showModal_CloseOrder, setShowModal_CloseOrder] = useState(false);   
    const requestCloseModal_CloseOrder = () => { setShowModal_CloseOrder(false); getOrderListingTable(); }
    const openModal_CloseOrder = () => { setShowModal_CloseOrder(true); }

    //SIGNATURE ORDER MODAL CONTROLLER
    const [showModal_SignatureOrder, setShowModal_SignatureOrder] = useState(false);   
    const requestCloseModal_SignatureOrder = () => { setShowModal_SignatureOrder(false); getOrderListingTable(); }
    const openModal_SignatureOrder = () => { setShowModal_SignatureOrder(true); }
    
    //INFO ORDER MODAL CONTROLLER
    const [showModal_InfoOrder, setShowModal_InfoOrder] = useState(false);   
    const requestCloseModal_InfoOrder = () => { setShowModal_InfoOrder(false); getOrderListingTable(); }
    const openModal_InfoOrder = () => { setShowModal_InfoOrder(true); }

    //LOG ORDER MODAL CONTROLLER
    const [showModal_LogOrder, setShowModal_LogOrder] = useState(false);   
    const requestCloseModal_LogOrder = () => { setShowModal_LogOrder(false); }
    const openModal_LogOrder = () => { setShowModal_LogOrder(true); }

    //PAUSE ORDER MODAL CONTROLLER
    const [showModal_PauseOrder, setShowModal_PauseOrder] = useState(false);   
    const requestCloseModal_PauseOrder = () => { setShowModal_PauseOrder(false); getOrderListingTable(); }
    const openModal_PauseOrder = () => { setShowModal_PauseOrder(true); }


    const [orderTable, setOrderTable] = useState([]);

    const [technicalCombo, setTechnicalCombo] = useState([]);
    
    //SEARCHER COMPONENTS
    const [technicalSearcher, setTechnicalSearcher] = useState("");
    const [customerSearcher, setCustomerSearcher] = useState("");
    
    const [statusSearcher, setStatusSearcher] = useState("");


    const [serieSearcher, setSerieSearcher] = useState("");
    const [invoicerSearcher, setInvoicerSearcher] = useState("");
    const [addressSearcher, setAddressSearcher] = useState("");
    const [modelSearcher, setModelSearcher] = useState("");
    const [failureSearcher, setFailureSearcher] = useState("");


    //LOADING STATE BY ID
    const [loadingID_desktop, setLoadingID_desktop] = useState(false);   
    const [loadingID_mobile, setLoadingID_mobile] = useState(false);   
    

    //
    const [orderID, setOrderID] = useState(null);


    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const [objOrder, setObjOrder] = useState([]);

    const [blockSearchInput, setBlockSearchInput] = useState(false);


    //
    const [waitingFlag, setWaitingFlag] = useState(false);

    //
    useEffect(() => {

        //RESET TABLE
        setOrderTable([]);

        //GRAPHICS EFFECT
        setWaitingFlag(true);

        //SHOW ORDER LISTING
        getOrderListingTable();


    }, [statusSearcher, serieSearcher, technicalSearcher, customerSearcher,invoicerSearcher, dateRange, addressSearcher, modelSearcher, failureSearcher]);


    //
    const storeSerieSearcher = (input) => {


        //
        if(input === "") { setBlockSearchInput(false); } 
        else { setBlockSearchInput(true); }


        //CLEAR FIELDS
        setDateRange("","");
        

        //
        setSerieSearcher(input);

        //
        setAddressSearcher("");

        //
        setFailureSearcher("");

        //
        setModelSearcher("");

        //
        setCustomerSearcher("");

        //
        setInvoicerSearcher("");

        //
        setTechnicalSearcher("");

        //
        setStatusSearcher("");


    } //END FUNCTION

    //
    const storeAddressSearcher = (input) => {


        //
        setAddressSearcher(input);

        /*
        //CLEAR FIELDS
        setDateRange("","");
        
        //
        setFailureSearcher("");

        //
        setModelSearcher("");

        //
        setSerieSearcher("");

        //
        setCustomerSearcher("");

        //
        setInvoicerSearcher("");

        //
        setTechnicalSearcher("");

        //
        setStatusSearcher("");
        */

    } //END FUNCTION

    //
    const storeFailureSearcher = (input) => {


        //
        setFailureSearcher(input);

        /*

        //CLEAR FIELDS
        setDateRange("","");
        
        //
        setAddressSearcher("");

        //
        setModelSearcher("");
        
        //
        setSerieSearcher("");

        //
        setCustomerSearcher("");

        //
        setInvoicerSearcher("");

        //
        setTechnicalSearcher("");

        //
        setStatusSearcher("");
        */

    } //END FUNCTION

    //
    const storeModelSearcher = (input) => {


        //
        setModelSearcher(input);

        /*
        //CLEAR FIELDS
        setDateRange("","");

        //
        setFailureSearcher("");

        //
        setAddressSearcher("");
        
        //
        setSerieSearcher("");

        //
        setCustomerSearcher("");

        //
        setInvoicerSearcher("");

        //
        setTechnicalSearcher("");

        //
        setStatusSearcher("");
        */

    } //END FUNCTION

    const startServices = async (orderID) => {

        //GET ORDER INFORMATION
        let endpoint = "getOrderByID?order_id=" + orderID;


        let response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        let responseContent = await response.json();

        let metadata = JSON.parse(responseContent.metadata);


        //UPDATE ORDER STATUS
        endpoint = "updateOrder?orderID=" + orderID;

        //
        let rawBody = {
            "customer": metadata.customer,
            "model": metadata.model,
            "serialNumber":metadata.serialNumber,
            "failure":metadata.failure,
            "personContact": metadata.personContact,
            "issuesDate": metadata.issuesDate,
            "status": "Servicio Iniciado",
            "tecnico": metadata.tecnico,
            "address": metadata.address,
            "serviceInvoice": metadata.serviceInvoice,
            "personContactData": metadata.personContactData,
            "notes":metadata.notes
        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(rawBody).replace(/"/g, '\\"') + "\"}";

        //
        response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: requestBody
        });

        responseContent = await response.json();

        //REFRESH TABLE
        getOrderListingTable();

        //STORE LOG INFORMATION
        storeOrderLog(orderID, sessionUser.customer_name, "Servicio Iniciado", "");

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });
        
    } //END FUNCTION

    //FUNCTION TOOL CONVERT
    const convertDate2SQL= (inputDate) => {
        
        const outputDate = moment(inputDate, "DD/MM/YYYY").format("YYYY-MM-DD");

        return outputDate;

    }//END FUNCTION

    const getOrderListingTable = async () => {


        //
        //BUILD BODY POST
        //

        let requestBody ="[";

        
        //IF USER IS CUSTOMER
        if(sessionUser.groupname === "Clientes") { 
            
            requestBody = requestBody + "{\"property_name\": \"customer\", \"property_value\":\"" + sessionUser.customer_name.trim() + "\" } " 
       
        } else {

            //
            if(customerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"customer\", \"property_value\":\"" + customerSearcher.trim() + "\" } "  }

        }


        //
        if(customerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"customer\", \"property_value\":\"" + customerSearcher.trim() + "\" } "  }
    
        //
        if(statusSearcher !== ""){ requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"status\", \"property_value\":\"" + statusSearcher.trim() + "\" } "  }

        //
        if(technicalSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"tecnico\", \"property_value\":\"" + technicalSearcher.trim() + "\" } "  }

        //
        if(serieSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"serialNumber\", \"property_value\":\"" + serieSearcher.trim() + "\" } "  }

        //
        if(invoicerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"serviceInvoice\", \"property_value\":\"" + invoicerSearcher.trim() + "\" } "  }

        //
        if(addressSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"address\", \"property_value\":\"" + addressSearcher.trim() + "\" } "  }

        //
        if(modelSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"model\", \"property_value\":\"" + modelSearcher.trim() + "\" } "  }

        //
        if(failureSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"failure\", \"property_value\":\"" + failureSearcher.trim() + "\" } "  }

       
        
        requestBody = requestBody + "]";

        //
        //END BUILD BODY POST
        //

        //CHECK SEARCH BY ISSUES DATE
        let queryString = "";
        if(startDate && endDate){ queryString = "?fieldDate=issuesDate&startDate=" + convertDate2SQL(startDate) + "&endDate=" + convertDate2SQL(endDate); }

        console.log(requestBody);
        
        

        const endpoint = "getOrderListingByCriteria" + queryString

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: requestBody
        });

        const responseContent = await response.json();

        
        //CLEAN DONE ORDERS WHEN TODOS | ACTIVOS
        if(statusSearcher === "" && serieSearcher === "") {
            
            let orderListing = new Array();
            
            responseContent.forEach((item)=>{
                                
                let orderMetadata = JSON.parse(item.metadata);

                if(orderMetadata.status != "Solicitud finalizada" && orderMetadata.status != "Solicitud desactivada") { orderListing.push(item); }

            });

            //POPULATE TABLE
            setOrderTable(orderListing);

        } else {

            //POPULATE TABLE
            setOrderTable(responseContent);

        }


        //GRAPHICS EFFECT
        setWaitingFlag(false);
       

    } //END FUNCTION


    const getUsersListing = async () =>{

        const endpoint = "getUsersListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        const responseContent = await response.json();

        setTechnicalCombo(responseContent);


    } //END FUNCTION


    const buildPDF = async (currentOrderID) => {

        //GRAPH EFFECT
        setLoadingID_desktop(currentOrderID);
        setLoadingID_mobile(currentOrderID);


        //GET ORDER INFO
        let endpoint = "getOrderByID?order_id=" + currentOrderID;

        let response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        let responseContent = await response.json();

        const metadata = JSON.parse(responseContent.metadata);
        

        //FILL TEMPLATE
        let requestBody = {
            "templateName":"service_template.html",
            "values":[
                {
                    "fieldName":"##ORDER_ID",
                    "fieldValue": "" + currentOrderID + ""
                },
                {
                    "fieldName":"##SD_0",
                    "fieldValue": "" + metadata.customer + ""
                },
                {
                    "fieldName":"##SD_1",
                    "fieldValue": "" + metadata.model + ""
                },
                {
                    "fieldName":"##SD_2",
                    "fieldValue": "" + metadata.serialNumber + ""
                },
                {
                    "fieldName":"##SD_3",
                    "fieldValue": "" + metadata.failure + ""
                },
                {
                    "fieldName":"##SD_4",
                    "fieldValue": "" + metadata.personContact + ""
                },
                {
                    "fieldName":"##SD_5",
                    "fieldValue": "" + metadata.tecnico + ""
                },
                {
                    "fieldName":"##SD_6",
                    "fieldValue": "" + metadata.address + ""
                },
                {
                    "fieldName":"##SD_7",
                    "fieldValue": "" + metadata.issuesDate + ""
                },
                {
                    "fieldName":"##TEC_REPORT",
                    "fieldValue": "" + metadata.technicalReport + ""
                },
                {
                    "fieldName":"##CUSTOMER_SIGNATURE",
                    "fieldValue": "<img style='height: 100px' src='" + metadata.customerSignature + "' alt:'firma' />"
                },
                {
                    "fieldName":"##ACLARACION",
                    "fieldValue": "" + metadata.signerName + ""
                },
                {
                    "fieldName":"##DNI",
                    "fieldValue": "" + metadata.signerDNI + ""
                },
                {
                    "fieldName":"##DEVICE_COUNTER",
                    "fieldValue": "" + metadata.counterDevice + ""
                },
                {
                    "fieldName":"##SERVICE_TYPE",
                    "fieldValue": "" + metadata.serviceType + ""
                },
            ]
        };

        endpoint = "FillTemplate"

        response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(requestBody)
        });

        responseContent = await response.json();


        //BUILD PDF
        requestBody = {
            "html":"" + responseContent.templateString + "",
            "margins":"0",
            "return_method":"b64"
        };

        endpoint = "convertHTML2PDF"

        response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(requestBody)
        });

        //
        responseContent = await response.json();


        if (responseContent.pdF_B64) {

            const link = document.createElement("a");
            link.href = `data:application/pdf;base64,${responseContent.pdF_B64}`;
            link.download = `Informe_Servicio_${currentOrderID}.pdf`;
            link.click();

            //DEPRECATED WAY - FAIL IN MOBILE ENVIOREMENTS
            //const pdfWindow = window.open();
            //pdfWindow.document.write('<embed src="data:application/pdf;base64,' + responseContent.pdF_B64 + '" width="100%" height="100%" />');
            
        }

        //STOP SPINNER
        setLoadingID_desktop("");
        setLoadingID_mobile("");


    } //END FUNCTION


    const exportToExcel = async () => { 

        //
        try {

            
            //
            //BUILD BODY POST
            //

            let requestBody ="[";


            //IF USER IS CUSTOMER
            if(sessionUser.groupname === "Clientes") { 
                
                requestBody = requestBody + "{\"property_name\": \"customer\", \"property_value\":\"" + sessionUser.customer_name.trim() + "\" } " 
            

            } else {

                //
                if(customerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"customer\", \"property_value\":\"" + customerSearcher.trim() + "\" } "  }
            
            }

  
            //
            if(customerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"customer\", \"property_value\":\"" + customerSearcher.trim() + "\" } "  }
        
            //
            if(statusSearcher !== ""){ requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"status\", \"property_value\":\"" + statusSearcher.trim() + "\" } "  }

            //
            if(technicalSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"tecnico\", \"property_value\":\"" + technicalSearcher.trim() + "\" } "  }

            //
            if(serieSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"serialNumber\", \"property_value\":\"" + serieSearcher.trim() + "\" } "  }

            //
            if(invoicerSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"serviceInvoice\", \"property_value\":\"" + invoicerSearcher.trim() + "\" } "  }

            //
            if(addressSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"address\", \"property_value\":\"" + addressSearcher.trim() + "\" } "  }

            //
            if(modelSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"model\", \"property_value\":\"" + modelSearcher.trim() + "\" } "  }

            //
            if(failureSearcher !== "") {  requestBody = requestBody + (requestBody !== "[" ? "," : "") + "{\"property_name\": \"failure\", \"property_value\":\"" + failureSearcher.trim() + "\" } "  }

        
            
            requestBody = requestBody + "]";

            //
            //END BUILD BODY POST
            //

            //CHECK SEARCH BY ISSUES DATE
            let queryString = "";
            if(startDate && endDate){ queryString = "?fieldDate=issuesDate&startDate=" + convertDate2SQL(startDate) + "&endDate=" + convertDate2SQL(endDate); }

            
            const endpoint = "getOrderListingByCriteria" + queryString

            const response = await fetch(apiUrl + endpoint,
            {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: requestBody
            });

            const responseContent = await response.json();


            let excelRows = new Array();

            //CLEAN DONE ORDERS WHEN TODOS | ACTIVOS
            if(statusSearcher === "" && serieSearcher === "") {
                
                let orderListing = new Array();
                
                responseContent.forEach((item)=>{
                                    
                    let orderMetadata = JSON.parse(item.metadata);

                    if(orderMetadata.status != "Solicitud finalizada" && orderMetadata.status != "Solicitud desactivada") { orderListing.push(item); }

                });

                //POPULATE TABLE
                setOrderTable(orderListing);
                excelRows = orderListing;

            } else {

                //POPULATE TABLE
                setOrderTable(responseContent);
                excelRows = responseContent;

            }

            
            const mappedData = excelRows.map(item => {

                let metadata = JSON.parse(item.metadata);
                console.log(metadata);
                return {
                    'Nro de Servicio': item.order_id,
                    'Cliente': metadata.customer,
                    'Modelo': metadata.model,
                    'Serial': metadata.serialNumber,
                    'Falla': metadata.failure,
                    'Contacto': metadata.personContact,
                    'Fecha de Creación': metadata.issuesDate,
                    'Estado': metadata.status,
                    'Técnico Asignado': metadata.tecnico,
                    'Direccion': metadata.address,
                    'Serv. Facturable' : metadata.serviceInvoice,
                    'Reporte Técnico' : metadata.technicalReport,
                    'Contador' :metadata.counterDevice
                };

              });
          
          
              const ws = XLSX.utils.json_to_sheet(mappedData);        
          
              const wb = XLSX.utils.book_new();
          
              XLSX.utils.book_append_sheet(wb, ws, 'Reporte');
          
              XLSX.writeFile(wb, 'Reporte Servicios.xlsx');


        } catch (error) {
                console.error(error);
        }


    } //END FUNCTION


    const inactivateService = (currentOrderID) => {



        Swal.fire({
            title: '<span style="font-size: 16px">¿Desea desactivar la orden de servicio Nro ' + currentOrderID + '?</span>',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Si, Desactivar',
            //denyButtonText: `No, Cerrar Ventana`,
            }).then(async (result) => {
            

            if (result.isConfirmed) {

                //GET ORDER INFORMATION
                let endpoint = "getOrderByID?order_id=" + currentOrderID;


                let response = await fetch(apiUrl + endpoint,
                {
                    method: "GET",
                    headers: {"Content-Type": "application/json"}
                });

                let responseContent = await response.json();

                let metadata = JSON.parse(responseContent.metadata);


                //UPDATE ORDER STATUS
                endpoint = "updateOrder?orderID=" + currentOrderID;

                //
                let rawBody = {
                    "customer": metadata.customer,
                    "model": metadata.model,
                    "serialNumber":metadata.serialNumber,
                    "failure":metadata.failure,
                    "personContact": metadata.personContact,
                    "issuesDate": metadata.issuesDate,
                    "status": "Solicitud desactivada",
                    "tecnico": metadata.tecnico,
                    "address": metadata.address,
                    "serviceInvoice": metadata.serviceInvoice,
                    "personContactData": metadata.personContactData,
                    "lastStatus":metadata.status,
                    "notes":metadata.notes
                };

                //
                const requestBody ="{\"metadata\":\"" + JSON.stringify(rawBody).replace(/"/g, '\\"') + "\"}";

                //
                response = await fetch(apiUrl + endpoint,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: requestBody
                });

                responseContent = await response.json();

                //REFRESH TABLE
                getOrderListingTable();

                //STORE LOG INFORMATION
                storeOrderLog(currentOrderID, sessionUser.customer_name, "Solicitud Desactivada", "");

                //Show message sweet alert
                Swal.fire({
                    title: "¡Éxito!",
                    text: "Operación realizada exitosamente.",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                
            } //END IF

        }) //END SWAL

    } //END FUNCTION


     const reactivateService = (currentOrderID) => {



        Swal.fire({
            title: '<span style="font-size: 16px">¿Desea reactivar la orden de servicio Nro ' + currentOrderID + '?</span>',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Si, Reactivar',
            //denyButtonText: `No, Cerrar Ventana`,
            }).then(async (result) => {
            

            if (result.isConfirmed) {

                //GET ORDER INFORMATION
                let endpoint = "getOrderByID?order_id=" + currentOrderID;


                let response = await fetch(apiUrl + endpoint,
                {
                    method: "GET",
                    headers: {"Content-Type": "application/json"}
                });

                let responseContent = await response.json();

                let metadata = JSON.parse(responseContent.metadata);


                //UPDATE ORDER STATUS
                endpoint = "updateOrder?orderID=" + currentOrderID;

                //
                let rawBody = {
                    "customer": metadata.customer,
                    "model": metadata.model,
                    "serialNumber":metadata.serialNumber,
                    "failure":metadata.failure,
                    "personContact": metadata.personContact,
                    "issuesDate": metadata.issuesDate,
                    "status": metadata.lastStatus,
                    "tecnico": metadata.tecnico,
                    "address": metadata.address,
                    "serviceInvoice": metadata.serviceInvoice,
                    "personContactData": metadata.personContactData,
                    "notes":metadata.notes
                    
                };

                //
                const requestBody ="{\"metadata\":\"" + JSON.stringify(rawBody).replace(/"/g, '\\"') + "\"}";

                //
                response = await fetch(apiUrl + endpoint,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: requestBody
                });

                responseContent = await response.json();

                //REFRESH TABLE
                getOrderListingTable();

                //STORE LOG INFORMATION
                storeOrderLog(currentOrderID, sessionUser.customer_name, "Solicitud Reactivada", "");

                //Show message sweet alert
                Swal.fire({
                    title: "¡Éxito!",
                    text: "Operación realizada exitosamente.",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                
            } //END IF

        }) //END SWAL

    } //END FUNCTION


    useEffect(()=>{ 

        //Check Session
        const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

        //
        if(!sessionUser) {   
            window.location.href = "/"; 
        }


        //
        getOrderListingTable(); 


        //
        getUsersListing();


        
    }, []);

    
    return (
        <div style={{paddingLeft: "20px", paddingRight: "20px"}}>

            {/* SEARCH BOXES */}
            <Card variant="primary">
                <Card.Header style={{backgroundColor: "#404661", color: "white"}}></Card.Header>
                <Card.Body>

                    <Row className="d-block d-sm-none d-md-none d-lg-none">
                        <Col md={12}>
                            <Row>

                                <>
                                    {/* Admnistradores y tecnicos */}

                                    <Col xs={12} md={4}>
                                        <Form.Label className='subTitle_1'>Rango de Fecha de Creación</Form.Label><br />
                                        <DatePicker
                                            wrapperClassName="full-width-datepicker"
                                            className="form-control"
                                            disabled={blockSearchInput}
                                            selectsRange
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => setDateRange(update)}
                                            isClearable={true}
                                            style={{ width: '100%' }}
                                            />
                                    </Col>
                                    <Col xs={12} md={4}>

                                        <Form.Label className='subTitle_1'>Cliente</Form.Label>

                                        { sessionUser.groupname !== "Clientes" ? (
                                            <Form.Select 
                                                disabled={blockSearchInput} 
                                                value={customerSearcher}
                                                style={{fontSize:"14px" }} onChange={(e)=>{setCustomerSearcher(e.target.value); }} >

                                                <option style={{fontSize:"14px"}} value="">Todos</option>

                                                { technicalCombo.map((item)=>{

                                                    return (
                                                        (item.groupname === "Clientes" ? (
                                                        <option style={{fontSize:"14px"}}>{item.customer_name}</option> ) : "" )
                                                    )

                                                })}

                                            </Form.Select>
                                        ) : 

                                            <Form.Control 
                                                type="text" 
                                                value={sessionUser.customer_name}
                                                disabled={true}
                                                placeholder="" />
                                        
                                        }


                                    </Col>
                                    <Col xs={12} md={4}>
                                        <Form.Label className='subTitle_1'>Técnico</Form.Label>
                                        <Form.Select 
                                            disabled={blockSearchInput} 
                                            value={technicalSearcher}
                                            style={{fontSize:"14px"}} onChange={(e)=>{setTechnicalSearcher(e.target.value); }}>

                                            <option style={{fontSize:"14px"}}value="">Todos</option>

                                            { technicalCombo.map((item)=>{

                                                return (
                                                    (item.groupname === "Técnicos" ? (
                                                    <option style={{fontSize:"14px"}} >{item.customer_name}</option> ) : "" )
                                                )

                                            })}

                                        </Form.Select>
                                    </Col>


                                    { sessionUser.groupname === "Administrativos" ? (
                                    <Col xs={12} md={4} style={{marginTop:"15px"}} >
                                        <Form.Label className='subTitle_1'>Serv. Facturable</Form.Label>
                                        <Form.Select 
                                            disabled={blockSearchInput} 
                                            value={invoicerSearcher}
                                            style={{fontSize:"14px" }} onChange={(e)=>{setInvoicerSearcher(e.target.value); }} 
                                            >
                                            <option style={{fontSize:"14px"}} value="">Todos</option>
                                            <option style={{fontSize:"14px"}} value="Si" >Si</option>
                                            <option style={{fontSize:"14px"}} value="No" >No</option>

                                        </Form.Select>
                                    </Col>
                                    ) : "" }


                                    <Col xs={12} md={4} style={{marginTop:"15px"}}>
                                        <Form.Label className='subTitle_1'>Nro. Serie</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            onChange={(event)=>storeSerieSearcher(event.target.value)}
                                            placeholder="" />
                                    </Col>


                                    <Col xs={12} md={4} style={{marginTop:"15px"}}>
                                        <Form.Label className='subTitle_1'>Estado</Form.Label>
                                        <Form.Select 
                                            value={statusSearcher}
                                            disabled={blockSearchInput} 
                                            style={{fontSize:"14px"}} onChange={(e)=>{setStatusSearcher(e.target.value); }} 
                                            >
                                            <option style={{fontSize:"14px"}} value="">Todos | Activos</option>
                                            <option style={{fontSize:"14px"}} value="Por asignar técnico" >Por asignar técnico</option>
                                            <option style={{fontSize:"14px"}} value="Técnico asignado" >Técnico asignado</option>
                                            <option style={{fontSize:"14px"}} value="En espera de firma del cliente" >En espera de firma del cliente</option>
                                            <option style={{fontSize:"14px"}} value="Solicitud finalizada" >Solicitud finalizada</option>
                                            <option style={{fontSize:"14px"}} value="Solicitud desactivada" >Solicitud desactivada</option>

                                        </Form.Select>
                                    </Col>

                                    <Col xs={12} md={4} style={{marginTop:"15px"}}>
                                        <Form.Label className='subTitle_1'>Falla</Form.Label>
                                        <Form.Control 
                                        type="text"
                                        value={failureSearcher}
                                        disabled={blockSearchInput}
                                        onChange={(event)=>storeFailureSearcher(event.target.value)}
                                        />
                                    </Col>

                                    <Col xs={12} md={4} style={{marginTop:"15px"}}>
                                        <Form.Label className='subTitle_1'>Modelo</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        value={modelSearcher}
                                        disabled={blockSearchInput}
                                        onChange={(event)=>storeModelSearcher(event.target.value)}
                                        />
                                    </Col>

                                     <Col xs={12} md={4} style={{marginTop:"15px"}}>
                                        <Form.Label className='subTitle_1'>Direccion</Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        value={addressSearcher}
                                        disabled={blockSearchInput}
                                        onChange={(event)=>storeAddressSearcher(event.target.value)}
                                        />
                                    </Col>

                                </>  
                               
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        { sessionUser.groupname === "Administrativos" ? (
                            <Col xs={12} sm={6} style={{marginTop:"10px"}} >
                                <Form.Label className='subTitle_1'>Serv. Facturable</Form.Label>
                                <Form.Select 
                                    value={invoicerSearcher}
                                    style={{fontSize:"14px" }} onChange={(e)=>{setInvoicerSearcher(e.target.value); }} 
                                    >
                                    <option style={{fontSize:"14px"}} value="">Todos</option>
                                    <option style={{fontSize:"14px"}} value="Si" >Si</option>
                                    <option style={{fontSize:"14px"}} value="No" >No</option>

                                </Form.Select>
                            </Col>
                        ) : <Col sm={6}></Col> }
                        <Col sm={6} xs={12} style={{textAlign: "right", marginTop:"20px"}}>


                            <Button 
                                variant="outline-primary"
                                size="sm"
                                style={{width: "210px", marginLeft:"10px" }}
                                onClick={openModal_AddOrder}
                            >
                                Agregar Nuevo Servicio
                                <FontAwesomeIcon icon={faCirclePlus}
                                style={{paddingLeft:"20px"}}/>
                            </Button>
                                

                            <Button 
                                variant="success"
                                size="sm"
                                style={{width: "50px", marginLeft:"10px"}}
                                onClick={exportToExcel}
                            >
                                <FontAwesomeIcon icon={faFileExcel}
                                style={{fontSize:"16px"}}
                                />
                            </Button>
                            

                            

                        </Col>
                    </Row>


                </Card.Body>
            </Card>
            <hr />


            {/* SERVICES TABLE (MOBILE) */}
            <Row style={{paddingLeft: "5px", paddingRight: "5px"}} className="d-block d-sm-none d-md-none d-lg-none">
                
                {waitingFlag ? <Row style={{textAlign:"center", color: "darkred"}}>
                                <Col>
                                    <FontAwesomeIcon 
                                        spin
                                        icon={faCircleNotch } 
                                        style={{}} 
                                    /> <span>Obteniendo datos, por favor espere...</span><hr />
                                </Col>
                            </Row> : ""}

                <Col xs={12}>

                {orderTable.length > 0 && orderTable.map((item)=>{

                    const meta = JSON.parse(item.metadata);

                    return (
                        <div style={{fontSize: "13px"}}>
                            <span className='spanLabelMobile'>Nro Servicio: </span> {item.order_id}<br />
                            <span className='spanLabelMobile'>Cliente: </span> {meta.customer}<br />
                            <span className='spanLabelMobile'>F. Creación: </span> {meta.issuesDate}<br />
                            <span className='spanLabelMobile'>Dirección: </span> {meta.address}<br />
                            <span className='spanLabelMobile'>Modelo: </span> {meta.model}<br />
                            <span className='spanLabelMobile'>Nro Serie: </span> {meta.serialNumber}<br />
                            <span className='spanLabelMobile'>Falla: </span> {meta.failure}<br />
                            <span className='spanLabelMobile'>Estado: </span> {meta.status}<br />
                            <span className='spanLabelMobile'>Técnico: </span> {meta.tecnico}<br />
                            <br />

                            <div className='actionsButton' onClick={()=> {setOrderID(item.order_id); openModal_LogOrder()}}>
                                <FontAwesomeIcon icon={faThList} 
                                style={{paddingLeft:"10px", paddingRight:"10px", color: "blue", cursor:"pointer"}} title='Bitácora Orden de Servicio'  />
                                Eventos
                            </div>

                            <br />
                            <div className='actionsButton' onClick={()=> {setOrderID(item.order_id); openModal_InfoOrder()}}>
                                <FontAwesomeIcon icon={faInfoCircle} 
                                style={{paddingLeft:"10px", paddingRight:"10px", color: "green", cursor:"pointer"}} title='Información Orden de Servicio' />
                                Info
                            </div>

                            <br />
                            <div className='actionsButton'  style={{display: (meta.status != "Solicitud finalizada" ? "" : "none" )}}  onClick={()=> {setOrderID(item.order_id); openModal_EditOrder()}}>
                                <FontAwesomeIcon icon={faPenToSquare} 
                                style={{paddingLeft:"10px", paddingRight:"10px", color: "black", cursor:"pointer" }} title='Editar Orden de Servicio' />
                                Editar
                            </div>



                            { (sessionUser.groupname !== "Clientes" && meta.status !== "Solicitud desactivada") ? (

                                <>
                                <br />
                                <div className='actionsButton' style={{ display: (meta.status != "Solicitud finalizada" ? "" : "none" ) }} onClick={()=> {inactivateService(item.order_id);}}>
                                    <FontAwesomeIcon icon={faTrash} 
                                    style={{paddingLeft:"10px", paddingRight:"10px", color: "darkred", cursor:"pointer" }}title='Editar Orden de Servicio' />
                                    Desactivar
                                </div>
                                </>

                            ) : ""
                            
                            
                            }


                            {meta.status === "Por asignar técnico" && sessionUser.groupname != "Clientes" ? (
                                <>
                                <br />
                                <div className='actionsButton' onClick={()=>{setOrderID(item.order_id); openModal_AssignOrder()}}>
                                     
                                    <FontAwesomeIcon icon={faUserPlus} 
                                    style={{paddingLeft:"10px", paddingRight:"10px", cursor:"pointer"}} title='Asignar Técnico'  />
                                    Asignar Técnico
                                </div>
                                </>
                                
                            ) : "" }

                            { (meta.status === "Técnico asignado" ||  meta.status === "Servicio en pausa") && sessionUser.groupname === "Técnicos" ? (
                                
                                <>
                                    <br />
                                    <div className='actionsButton' onClick={()=>{startServices(item.order_id)}}>
                                        
                                        <FontAwesomeIcon icon={faCirclePlay}
                                        style={{paddingLeft:"10px", paddingRight:"10px", cursor:"pointer" }} title='Iniciar Servicio'  />
                                        Iniciar Servicio
                                    </div>
                                </>

                                ) : "" }

                                {meta.status === "Servicio Iniciado" && sessionUser.groupname === "Técnicos" ? (
                                    <>
                                    <br />
                                    <div className='actionsButton' onClick={()=>{setOrderID(item.order_id); openModal_CloseOrder()}}>
                                        
                                        <FontAwesomeIcon icon={faSquareCheck} 
                                        style={{paddingLeft:"10px", paddingRight:"10px", cursor:"pointer" }} title='Cerrar Servicio'  />
                                        Cerrar Servicio

                                    </div>
                                    </>
                                    
                                ) : "" }


                                {meta.status === "Servicio Iniciado" && sessionUser.groupname === "Técnicos" ? (
                                    <>
                                    <br />
                                    <div className='actionsButton' onClick={()=>{setOrderID(item.order_id); openModal_PauseOrder()}}>
                                        
                                        <FontAwesomeIcon icon={faPause} 
                                        style={{paddingLeft:"10px", paddingRight:"10px", cursor:"pointer" }} title='Servicio en Espera' />
                                        Servicio en Espera

                                    </div>
                                    </>
                                    
                                ) : "" }


                                {meta.status === "En espera de firma del cliente" && sessionUser.groupname === "Técnicos" ? (
                                    <>
                                        <br />
                                        <div className='actionsButton' onClick={()=> {setOrderID(item.order_id); openModal_SignatureOrder() }}>
                                            
                                            <FontAwesomeIcon icon={faSignature} 
                                            style={{paddingLeft:"10px", paddingRight:"10px", cursor:"pointer"}} title='Firma del Cliente'  />
                                            Firma del Cliente
                                        
                                        </div>
                                    </>

                            ) : "" }


                                {meta.status === "Solicitud finalizada" ? (
                                    <>
                                    <br />
                                    <div className='actionsButton' onClick={()=>{ buildPDF(item.order_id) }} >
                                        
                                        <FontAwesomeIcon 
                                            icon={loadingID_mobile === item.order_id ? faCircleNotch : faFilePdf } 
                                            style={{paddingLeft:"10px", paddingRight:"10px", color:"darkred", cursor:"pointer"}} 
                                            spin={loadingID_mobile === item.order_id}
                                        />
                                        Informe en PDF
                                
                                    </div>
                                    </>
                                
                                
                            ) : "" }
                            <hr style={{border:"3px solid #000000"}} />
                        </div>
                    );
                            
                            
                })}
                </Col>
            </Row>


            {/* SERVICES TABLE (DESKTOP) */}
            <Row style={{paddingLeft: "5px", paddingRight: "5px"}} className="d-none d-sm-block">
                <Col xs={12}>
                <Table striped className="mainTable">
                    <thead>
                        <tr>
                            <th></th>
                            <th>

                                { sessionUser.groupname !== "Clientes" ? (

                                    <Form.Select 
                                        value={customerSearcher}
                                        style={{fontSize:"12px" }} onChange={(e)=>{setCustomerSearcher(e.target.value); }} 
                                        disabled={blockSearchInput}
                                        >
                                        
                                        <option style={{fontSize:"12px"}} value="">Todos</option>

                                        { technicalCombo.map((item)=>{

                                            return (
                                                (item.groupname === "Clientes" ? (
                                                <option style={{fontSize:"14px"}}>{item.customer_name}</option> ) : "" )
                                            )

                                        })}
                                    </Form.Select>

                                ) : 
                                    <Form.Control 
                                        type="text" 
                                        value={sessionUser.customer_name}
                                        disabled={true}/>
                                
                                }



                            </th>
                            <th>
                                <DatePicker
                                    wrapperClassName="full-width-datepicker"
                                    className="form-control"
                                    selectsRange
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => setDateRange(update)}
                                    isClearable={true}
                                    style={{ width: '100%' }}
                                    />
                            </th>
                            <th>
                                <Form.Control 
                                    type="text" 
                                    value={addressSearcher}
                                    disabled={blockSearchInput}
                                    onChange={(event)=>storeAddressSearcher(event.target.value)}
                                    placeholder="Dirección" />
                            </th>
                            <th>
                                <Form.Control 
                                    type="text" 
                                    value={modelSearcher}
                                    disabled={blockSearchInput}
                                    onChange={(event)=>storeModelSearcher(event.target.value)}
                                    placeholder="Modelo" />
                            </th>
                            <th>
                                <Form.Control 
                                    type="text" 
                                    value={serieSearcher}
                                    onChange={(event)=>storeSerieSearcher(event.target.value)}
                                    placeholder="Nro. Serie" />
                            </th>
                            <th>
                                <Form.Control 
                                    type="text"
                                    value={failureSearcher}
                                    disabled={blockSearchInput}
                                    onChange={(event)=>storeFailureSearcher(event.target.value)}
                                    placeholder="Falla" />
                            </th>
                            <th>
                                <Form.Select 
                                    value={statusSearcher}
                                    disabled={blockSearchInput}
                                    style={{fontSize:"12px"}} onChange={(e)=>{setStatusSearcher(e.target.value); }} 
                                    >
                                    <option style={{fontSize:"12px"}} value="">Activos</option>
                                    <option style={{fontSize:"12px"}} value="Por asignar técnico" >Por asignar técnico</option>
                                    <option style={{fontSize:"12px"}} value="Técnico asignado" >Técnico asignado</option>
                                    <option style={{fontSize:"12px"}} value="En espera de firma del cliente" >En espera de firma del cliente</option>
                                    <option style={{fontSize:"12px"}} value="Solicitud finalizada" >Solicitud finalizada</option>
                                    <option style={{fontSize:"12px"}} value="Solicitud desactivada" >Solicitud desactivada</option>

                                </Form.Select>
                            </th>
                            <th>
                               
                                <Form.Select 
                                    value={technicalSearcher}
                                    disabled={blockSearchInput}
                                    style={{fontSize:"12px"}} onChange={(e)=>{setTechnicalSearcher(e.target.value); }}>

                                    <option style={{fontSize:"12px"}}value="">Todos</option>

                                    { technicalCombo.map((item)=>{

                                        return (
                                            (item.groupname === "Técnicos" ? (
                                            <option style={{fontSize:"12px"}} >{item.customer_name}</option> ) : "" )
                                        )

                                    })}

                                </Form.Select>

                            </th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>Serv.</th>
                            <th>Cliente</th>
                            <th>F. Creación</th>
                            <th>Dirección</th>
                            <th>Modelo</th>
                            <th>N° Serie</th>
                            <th>Falla</th>
                            <th>Estado</th>
                            <th>Técnico</th>
                            <th style={{textAlign:"center", width:"150px"}}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>

                        
                        {waitingFlag ? <tr>
                                           <td colSpan={10} style={{textAlign: "center", color: "darkred"}}>
                                                <FontAwesomeIcon 
                                                    spin
                                                    icon={faCircleNotch } 
                                                    style={{}} 
                                                  /> Obteniendo datos, por favor espere...
                                            </td>
                                            </tr> : ""}

                        {orderTable.length > 0 && orderTable.map((item)=>{

                            const meta = JSON.parse(item.metadata);

                            return (

                                <tr key={item.order_id}>
                                    <td>{item.order_id}</td>
                                    <td>{meta.customer}</td>
                                    <td>{meta.issuesDate}</td>
                                    <td>{meta.address}</td>
                                    <td>{meta.model}</td>
                                    <td>{meta.serialNumber}</td>
                                    <td>{meta.failure}</td>
                                    <td style={{color: (meta.status === "Por asignar técnico" ? "red" : "black")}}>{meta.status}</td>
                                    <td>{meta.tecnico}</td>

                                    <td style={{textAlign:"center"}}>
                                
   
                                        <FontAwesomeIcon icon={faThList} 
                                        style={{paddingLeft:"10px", color: "blue", cursor:"pointer"}} title='Bitácora Orden de Servicio' onClick={()=> {setOrderID(item.order_id); openModal_LogOrder()}} />

                                        <FontAwesomeIcon icon={faPenToSquare} 
                                        style={{paddingLeft:"10px", cursor:"pointer", display: (meta.status != "Solicitud finalizada" ? "" : "none" ) }} title='Editar Orden de Servicio' onClick={()=> {setOrderID(item.order_id); openModal_EditOrder()}} />

                                        <FontAwesomeIcon icon={faInfoCircle} 
                                        style={{paddingLeft:"10px", color: "green", cursor:"pointer"}} title='Información Orden de Servicio' onClick={()=> {setOrderID(item.order_id); openModal_InfoOrder()}} />


                                        { (sessionUser.groupname !== "Clientes" && meta.status !== "Solicitud desactivada") ? (
                                            <FontAwesomeIcon icon={faTrash} 
                                            style={{paddingLeft:"10px", color: "darkRed", cursor:"pointer"}} title='Inhabilitar Orden de Servicio' onClick={()=> {inactivateService(item.order_id);}} />
                                        ) : ""}


                                        { (sessionUser.groupname !== "Clientes" && meta.status === "Solicitud desactivada") ? (
                                            <FontAwesomeIcon icon={faRotateLeft} 
                                            style={{paddingLeft:"10px", color: "blue", cursor:"pointer"}} title='Reactivar Orden de Servicio' onClick={()=> {reactivateService(item.order_id);}} />
                                        ) : ""}


                                        {meta.status === "Por asignar técnico" && sessionUser.groupname !== "Clientes" ? (
                                            <FontAwesomeIcon icon={faUserPlus} 
                                            style={{paddingLeft:"10px", cursor:"pointer"}} title='Asignar Técnico' onClick={()=>{setOrderID(item.order_id); openModal_AssignOrder()}} />
                                        ) : "" }

                                        { (meta.status === "Técnico asignado" ||  meta.status === "Servicio en pausa") && sessionUser.groupname === "Técnicos" ? (
                                           
                                            <FontAwesomeIcon icon={faCirclePlay}
                                            style={{paddingLeft:"10px", cursor:"pointer" }} title='Iniciar Servicio' onClick={()=>{startServices(item.order_id)}} />
   
                                         ) : "" }

                                         {meta.status === "Servicio Iniciado" && sessionUser.groupname === "Técnicos" ? (
                                            <>
                                                
                                                <FontAwesomeIcon icon={faSquareCheck} 
                                                style={{paddingLeft:"20px", cursor:"pointer" }} title='Cerrar Servicio' onClick={()=>{setOrderID(item.order_id); openModal_CloseOrder()}} />
                                               
                                                <FontAwesomeIcon icon={faPause} 
                                                style={{paddingLeft:"20px", cursor:"pointer" }} title='Servicio en Espera' onClick={()=>{setOrderID(item.order_id); openModal_PauseOrder()}}/>
                                                
                                            </>
                                              
                                         ) : "" }

                                         {meta.status === "En espera de firma del cliente" && sessionUser.groupname === "Técnicos" ? (
                                            <>

                                                <FontAwesomeIcon icon={faSignature} 
                                                style={{paddingLeft:"10px", cursor:"pointer"}} title='Firma del Cliente' onClick={()=> {setOrderID(item.order_id); openModal_SignatureOrder() }} />
                                                
                                            </>

                                        ) : "" }


                                        


                                         {meta.status === "Solicitud finalizada" ? (

                                            <FontAwesomeIcon 
                                                icon={loadingID_desktop === item.order_id ? faCircleNotch : faFilePdf } 
                                                style={{marginLeft:"20px", color:"darkred", cursor:"pointer"}} 
                                                title='Informe en PDF' 
                                                spin={loadingID_mobile === item.order_id}
                                                onClick={()=>{ buildPDF(item.order_id) }} 
                                            />
                                            
                                        ) : "" }

                                    </td>
                                </tr>
                            )
                          
                        })}
                    </tbody>
                </Table>
                </Col>
            </Row>

            {/* MODAL ADD ORDER COMPONENT */}
            <NewOrderModal show={showModal_AddOrder} requestClose={requestCloseModal_AddOrder}/>

            {/* MODAL EDIT ORDER COMPONENT */}
            <EditOrderModal show={showModal_EditOrder} requestClose={requestCloseModal_EditOrder} orderID={orderID}/>

            {/* MODAL ASSIGN USER COMPONENT */}
            <AssignTechnicalModal show={showModal_AssignOrder} requestClose={requestCloseModal_AssignOrder} orderID={orderID}/>

            {/* MODAL close ORDER COMPONENT */}
            <CloseOrderModal show={showModal_CloseOrder} requestClose={requestCloseModal_CloseOrder} orderID={orderID} />

            {/* MODAL close ORDER COMPONENT */}
            <SignatureOrderModal show={showModal_SignatureOrder} requestClose={requestCloseModal_SignatureOrder} orderID={orderID}/>

            {/* MODAL INFO ORDER COMPONENT */}
            <InfoOrderModal show={showModal_InfoOrder} requestClose={requestCloseModal_InfoOrder} orderID={orderID} />

            {/* MODAL LOG ORDER COMPONENT */}
            <LogOrderModal show={showModal_LogOrder} requestClose={requestCloseModal_LogOrder} orderID={orderID} />

            {/* MODAL LOG ORDER COMPONENT */}
            <PauseOrderModal show={showModal_PauseOrder} requestClose={requestCloseModal_PauseOrder} orderID={orderID} />

        </div>

    );

}

export default OrdersMainTable;